import { hasAnalyticsConsent } from './analytics.js'

export const measurementId = 'G-QBRT3FJWE0'

function consentSettings(accepted) {
  return {
    analytics_storage: accepted ? 'granted' : 'denied',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
  }
}

export function updateGoogleAnalyticsConsent(accepted) {
  if (accepted) initializeGoogleAnalytics()
  window.gtag?.('consent', 'update', consentSettings(accepted))
}

export function trackPageView() {
  if (!hasAnalyticsConsent()) return
  window.gtag?.('event', 'page_view', {
    page_location: window.location.href,
    page_path: window.location.pathname,
    page_title: document.title,
  })
}

export function initializeGoogleAnalytics() {
  if (!hasAnalyticsConsent()) return
  if (window.gtag || document.querySelector('script[data-ncg-analytics]')) return

  window.dataLayer = window.dataLayer || []
  window.gtag = function gtag() { window.dataLayer.push(arguments) }
  window.gtag('js', new Date())
  window.gtag('consent', 'default', consentSettings(hasAnalyticsConsent()))
  window.gtag('config', measurementId, { send_page_view: false })

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`
  script.dataset.ncgAnalytics = 'true'
  document.head.append(script)
}
